import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as DownloadIcon } from "src/images/download.svg";
import { wsAxiosPost } from "src/helpers/wsAxios";
import { API_URLS } from "src/utils/API_URLS";
import { showToast } from "../../../../../../../methods/showToast";

export default function DownloadXlsxButton({
  selectedInfluencers,
  pagination = {},
  totalResults,
  projectId,
}) {
  const [isExporting, setIsExporting] = useState(false);

  const columns = useSelector((state) => state.creatorSearchReducer.columns);
  const hiddenColumns = useSelector(
    (state) => state.creatorSearchReducer.hiddenColumns,
  );

  const visibleColumns = columns
    .filter((column) => !hiddenColumns.includes(column.key))
    .map((column) => column.key);

  const handleDownloadXlsx = async () => {
    if (selectedInfluencers.length === 0) {
      return;
    }

    setIsExporting(true);

    try {
      // Add totalResults to pagination for backend to use as limit
      const paginationWithTotal = {
        ...pagination,
        ...(totalResults && { totalResults }),
      };

      await wsAxiosPost(
        API_URLS.exportCreatorSearchXlsx,
        {
          userIds: selectedInfluencers,
          pagination: paginationWithTotal,
          visibleColumns,
        },
        undefined, // errorMessage
        undefined, // initCallback
        undefined, // thenCallback
        undefined, // finallyCallback
        {
          headers: projectId ? { "Project-Uuid": projectId } : {},
        },
      );

      showToast(
        "info",
        <IDHFormattedMessage id="ws_info" defaultMessage="Info" />,
        <IDHFormattedMessage
          id="ws_creator_search_export_queued"
          defaultMessage="Your export has been queued. You will receive an email with the download link shortly."
        />,
      );
    } catch (error) {
      console.error("Export failed:", error);
      showToast(
        "error",
        <IDHFormattedMessage id="ws_error" defaultMessage="Error" />,
        <IDHFormattedMessage id="ws_error" defaultMessage="Error" />,
      );
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      size="medium"
      variant="white"
      onClick={handleDownloadXlsx}
      disabled={isExporting}
      data-qa="download-xlsx-button"
    >
      <DownloadIcon />
      <IDHFormattedMessage
        id="ws_download_xlsx"
        defaultMessage="Download XLSX"
      />
    </Button>
  );
}
